
import { Cloudinary } from "@cloudinary/url-gen";

/**
 * Configure your Cloudinary instance here.
 * Replace 'demo' with your actual cloud name from the Cloudinary Dashboard.
 */
export const cld = new Cloudinary({
  cloud: {
    cloudName: 'dgddwbftd'
  }
});

// Helper to get a transformed Cloudinary image URL
export const getCldImageUrl = (publicId: string) => {
  return cld.image(publicId)
    .format('auto')
    .quality('auto')
    .toURL();
};
